import { BsArrowLeft } from "react-icons/bs";

import Tooltip from "../../../shared/components/tooltip/tooltip";
import "./list-page.scss";
import { useBack } from "../../../shared/utils/use-back";
import { IDataUrl } from "../../utils";
import DataTable, { IColumn } from "../data-table/data-table";

export interface IListPageConfig {
  title: string;
  columns: IColumn[];
  dataUrl: IDataUrl;
  deleteUrl: IDataUrl | undefined;
  titleTooltip?: string;
  defaultSortCol: string;
}

const ListPage = ({
  columns,
  title,
  titleTooltip,
  dataUrl,
  deleteUrl,
  defaultSortCol,
}: IListPageConfig) => {
  const { handleBack } = useBack();

  return (
    <div className="listPage">
      <div onClick={() => handleBack()} className="listPage-navButton">
        <BsArrowLeft />
      </div>

      <div className="listPage-header">
        <h1>
          {title}
          {titleTooltip && <Tooltip content={titleTooltip} direction="top" delay={350} />}
        </h1>
      </div>

      <DataTable
        columns={columns}
        dataUrl={dataUrl}
        deleteUrl={deleteUrl}
        defaultSortCol={defaultSortCol}
        selectionMode={"multi"}
        navigate_to={"new"}
      />
    </div>
  );
};

export default ListPage;
